import { createStyled } from "@mui/system";
import getTheme from "../theme";
import i18next from "i18next";

const getStyled = () => {
  let theme = getTheme(i18next.dir());

  const styled = createStyled({ defaultTheme: theme });

  return { theme, styled };
};

export default getStyled;
